var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, require("@tamagui/simple-hash"), module.exports);
__reExport(src_exports, require("./clamp"), module.exports);
__reExport(src_exports, require("./composeEventHandlers"), module.exports);
__reExport(src_exports, require("./concatClassName"), module.exports);
__reExport(src_exports, require("./types"), module.exports);
__reExport(src_exports, require("./shouldRenderNativePlatform"), module.exports);
__reExport(src_exports, require("./validStyleProps"), module.exports);
__reExport(src_exports, require("./withStaticProperties"), module.exports);
//# sourceMappingURL=index.js.map
